import React, { useEffect } from "react";
import "../App.css";

const PrivacyPolicy = ({ onBack }) => {
  // Scroll handled globally

  return (
    <div className="legal-page-wrapper">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Privacy Policy</h1>
          <span className="legal-date">Last Updated: December 2025</span>
        </div>

        <div className="legal-content">
          <p>
            At MoonshotMap ("we", "our", or "us"), we understand that you are
            trusting us with your most valuable asset: your ideas. This Privacy
            Policy explains how we collect, use, and protect your strategic data
            when you use the MoonshotMap platform.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            We collect information to provide you with accurate Clarity Scores™
            and strategic roadmaps. This includes:
          </p>
          <ul>
            <li>
              <strong>Account Information:</strong> Name, email address, and
              authentication credentials.
            </li>
            <li>
              <strong>Strategic Inputs (Your Data):</strong> Pitch decks,
              business memos, financial models, raw notes, and goal descriptions
              you input into the Engine.
            </li>
            <li>
              <strong>Generated Outputs:</strong> The maps, scores, and roadmaps
              generated by our AI based on your inputs.
            </li>
            <li>
              <strong>Usage Analytics:</strong> Anonymized data on how you
              interact with the platform to help us improve performance.
            </li>
          </ul>

          <h2>2. How We Use Your Data</h2>
          <p>We use your data primarily to deliver our core service:</p>
          <ul>
            <li>
              <strong>AI Processing:</strong> Your Strategic Inputs are
              processed by our AI models solely to generate your specific
              outputs (Clarity Score, Fog Index, etc.).
            </li>
            <li>
              <strong>Service Improvement:</strong> We may use aggregated,
              anonymized data (e.g., "average pre-seed clarity scores") to
              benchmark market trends. We do <strong>not</strong> use your
              specific proprietary business ideas to train public AI models.
            </li>
            <li>
              <strong>Communication:</strong> To send you product updates,
              security alerts, and support messages.
            </li>
          </ul>

          <h2>3. Data Confidentiality & Security</h2>
          <p>
            Your startup ideas belong to you. We employ industry-standard
            encryption (TLS/SSL) for data in transit and at rest. Access to your
            Strategic Inputs is restricted to the automated AI processing
            pipeline; human review occurs only with your explicit permission for
            support purposes.
          </p>

          <h2>4. Third-Party Sharing</h2>
          <p>
            We do not sell your data. We share data only with trusted
            infrastructure providers necessary to run our service (e.g., cloud
            hosting, AI inference providers), all of whom are bound by strict
            data protection agreements.
          </p>

          <h2>5. Your Rights</h2>
          <p>
            You retain full ownership of your Strategic Inputs. You have the
            right to:
          </p>
          <ul>
            <li>
              <strong>Export:</strong> Download your maps and data at any time.
            </li>
            <li>
              <strong>Delete:</strong> Request complete deletion of your account
              and all associated data from our servers.
            </li>
          </ul>

          <h2>6. Updates to This Policy</h2>
          <p>
            We may update this policy as our technology evolves. If we make
            significant changes regarding how we handle your proprietary data,
            we will notify you via email.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            For privacy-related questions or to exercise your rights, please
            contact our Data Protection Officer at:{" "}
            <a href="mailto:hello@moonshotmap.com" className="email-link">
              hello@moonshotmap.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
